// extracted by mini-css-extract-plugin
export default {};
    if(module.hot) {
      // 1653763786741
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  